/* ==========================================================================
   OliveDrab — cart behaviour

   One controller for every cart surface marked [data-od-cart] (the cart page
   and the cart drawer). Every change goes through Shopify's cart API and the
   surface is then re-rendered with Section Rendering, so prices, sizes,
   discounts and availability are always the ones Liquid renders. Nothing is
   formatted here.

   Without this file every control still works as a plain form or link.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function asJs(url) { return String(url || '').replace(/\/$/, '').replace(/\.js$/, '') + '.js'; }

  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: HEADERS,
      credentials: 'same-origin',
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Request failed');
          err.data = data;
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  function withParam(url, key, value) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + key + '=' + encodeURIComponent(value);
  }

  var registry = [];

  /* ======================================================== controller */

  function Cart(root) {
    this.root = root;
    this.id = root.dataset.sectionId;
    this.routes = {
      cart: root.dataset.cartUrl || '/cart',
      add: asJs(root.dataset.addUrl || '/cart/add'),
      change: asJs(root.dataset.changeUrl || '/cart/change'),
      update: asJs(root.dataset.updateUrl || '/cart/update'),
      recs: root.dataset.recsUrl || '/recommendations/products',
      root: root.dataset.root || '/'
    };
    this.renderUrl = root.dataset.renderUrl || this.routes.cart;
    this.recsCache = {};
    this.freshProducts = {};
    this.bind();
    this.enhance();
    registry.push(this);
  }

  Cart.prototype.str = function (name, fallback) {
    var v = this.root.getAttribute('data-str-' + name);
    return v == null || v === '' ? fallback : v;
  };

  Cart.prototype.busy = function (on) {
    this.root.classList.toggle('is-busy', !!on);
    this.root.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  Cart.prototype.announce = function (msg) {
    var live = $('[data-od-cart-live]', this.root);
    if (!live || !msg) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  };

  /* ------------------------------------------------------------ render */

  Cart.prototype.render = function () {
    var self = this;
    var url = withParam(this.renderUrl, 'section_id', this.id);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-od-cart-inner]');
        var current = $('[data-od-cart-inner]', self.root);
        if (!fresh || !current) return;

        // express checkout buttons initialise themselves once; keep them
        var oldDyn = $('[data-od-dyn]', current);
        var newDyn = $('[data-od-dyn]', fresh);
        if (oldDyn && newDyn) newDyn.parentNode.replaceChild(oldDyn, newDyn);

        // keep scroll positions of rows a shopper may have swiped
        var keep = {};
        $$('[data-od-keep-scroll]', current).forEach(function (el) { keep[el.getAttribute('data-od-keep-scroll')] = el.scrollLeft; });

        current.parentNode.replaceChild(document.importNode(fresh, true), current);

        $$('[data-od-keep-scroll]', self.root).forEach(function (el) {
          var k = el.getAttribute('data-od-keep-scroll');
          if (keep[k]) el.scrollLeft = keep[k];
        });

        self.freshProducts = {};
        self.enhance();
        if (window.OD && window.OD.refresh) window.OD.refresh(self.root);
      });
  };

  Cart.prototype.after = function (msg, detail) {
    var self = this;
    return this.render().then(function () {
      self.busy(false);
      self.announce(msg);
      document.dispatchEvent(new CustomEvent('od:cart:changed', { detail: Object.assign({ source: self.id }, detail || {}) }));
    });
  };

  Cart.prototype.fail = function (err, where) {
    this.busy(false);
    var box = where && ($('[data-od-msg]', where) || (where.matches && where.matches('[data-od-msg]') ? where : null));
    var text = (err && err.data && (err.data.description || err.data.message)) || this.str('error', 'Something went wrong. Please try again.');
    if (box) {
      box.classList.remove('is-good');
      box.textContent = text;
    }
    this.announce(text);
  };

  /* --------------------------------------------------------- enhance */

  Cart.prototype.enhance = function () {
    var root = this.root;

    if (window.OD && window.OD.wishlist) {
      $$('[data-od-move-wish], [data-od-wish-rule]', root).forEach(function (el) { el.hidden = false; });
    }
    $$('[data-od-code-remove]', root).forEach(function (el) { el.hidden = false; });

    // the page-level checkout bar: let fixed widgets (chat) step above it
    if (root.hasAttribute('data-od-cart-page')) {
      document.documentElement.classList.toggle('od-cart-bar-on', !!$('[data-od-cart-bar]', root));
    }

    this.loadRecs();
    this.recsState();
  };

  /* ------------------------------------------------------------- cart ops */

  Cart.prototype.change = function (key, qty, msg) {
    var self = this;
    this.busy(true);
    return request(this.routes.change, { id: key, quantity: qty })
      .then(function () { return self.after(msg || self.str('updated', 'Your bag has been updated.')); })
      .catch(function (err) {
        var line = $('[data-od-line][data-key="' + key + '"]', self.root);
        self.fail(err, line);
        return self.render();
      });
  };

  Cart.prototype.add = function (form) {
    var self = this;
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var id = parseInt(idField && idField.value, 10);
    if (!id) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    this.busy(true);
    return request(this.routes.add, { items: [{ id: id, quantity: parseInt(qtyField && qtyField.value, 10) || 1 }] })
      .then(function (res) {
        document.dispatchEvent(new CustomEvent('od:cart:added', { detail: { items: res.items || [], source: self.id } }));
        return self.after(self.str('added', 'Added to your bag.'), { added: res.items || [] });
      })
      .catch(function (err) {
        if (btn) btn.removeAttribute('aria-busy');
        self.fail(err, form);
      });
  };

  Cart.prototype.swapSize = function (select) {
    var self = this;
    var key = select.dataset.key;
    var qty = parseInt(select.dataset.qty, 10) || 1;
    var id = parseInt(select.value, 10);
    var props = {};
    try { props = JSON.parse(select.dataset.properties || '{}') || {}; } catch (e) { props = {}; }
    // Liquid writes a line with no properties as [], which the cart API rejects
    if (Array.isArray(props) || typeof props !== 'object') props = {};
    var line = select.closest('[data-od-line]');
    this.busy(true);

    // add the new size first, so a size that has just sold out leaves the
    // original line untouched
    return request(this.routes.add, { items: [{ id: id, quantity: qty, properties: props }] })
      .then(function () { return request(self.routes.change, { id: key, quantity: 0 }); })
      .then(function () { return self.after(self.str('updated', 'Your bag has been updated.')); })
      .catch(function (err) {
        self.render().then(function () {
          var again = key && $('[data-od-line][data-key="' + key + '"]', self.root);
          self.fail(err && err.status === 422 ? { data: { description: self.str('size-error', 'That size has just sold out.') } } : err, again || line);
        });
      });
  };

  Cart.prototype.moveToWishlist = function (btn) {
    var w = window.OD && window.OD.wishlist;
    if (w && !w.has(btn.dataset.handle)) w.toggle(btn.dataset.handle, btn.dataset.id);
    return this.change(btn.dataset.key, 0, this.str('moved', 'Moved to your wishlist.'));
  };

  /* -------------------------------------------------------- discount codes */

  Cart.prototype.applyCode = function (form) {
    var self = this;
    var input = form.querySelector('input[name="discount"]');
    var code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    this.busy(true);

    var current = [];
    return request(asJs(this.routes.cart))
      .then(function (cart) {
        current = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return request(self.routes.update, { discount: current.concat([code]).join(',') });
      })
      .then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) {
          return self.after(self.str('code-applied', 'Code applied.')).then(function () {
            var box = $('[data-od-code] [data-od-msg]', self.root);
            if (box) { box.classList.add('is-good'); box.textContent = self.str('code-applied', 'Code applied.'); }
          });
        }
        // not valid for this bag: leave the bag's codes as they were
        return request(self.routes.update, { discount: current.join(',') })
          .then(function () { return self.render(); })
          .then(function () {
            self.busy(false);
            var f = $('[data-od-code]', self.root);
            var i = f && f.querySelector('input[name="discount"]');
            if (i) i.value = code;
            var box = f && $('[data-od-msg]', f);
            var text = self.str('code-invalid', "That code can't be used on this bag.");
            if (box) { box.classList.remove('is-good'); box.textContent = text; }
            self.announce(text);
          });
      })
      .catch(function () {
        // the cart API was unavailable: Shopify's own discount link applies it
        var back = window.location.pathname + window.location.search;
        // from the drawer, come back to the same page with the drawer open again
        if (self.root.getAttribute('data-reopen') === 'true') back += (back.indexOf('?') > -1 ? '&' : '?') + 'od_cart=open';
        window.location.href = self.routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(back);
      });
  };

  Cart.prototype.removeCode = function (code) {
    var self = this;
    this.busy(true);
    return request(asJs(this.routes.cart))
      .then(function (cart) {
        var keep = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable && String(d.code).toLowerCase() !== String(code).toLowerCase(); })
          .map(function (d) { return d.code; });
        return request(self.routes.update, { discount: keep.join(',') });
      })
      .then(function () { return self.after(self.str('updated', 'Your bag has been updated.')); })
      .catch(function (err) { self.fail(err); });
  };

  /* ------------------------------------------------ live size availability */

  Cart.prototype.refreshProduct = function (handle, scope) {
    var self = this;
    if (!handle || this.freshProducts[handle]) return;
    this.freshProducts[handle] = true;
    fetch(this.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        var avail = {};
        p.variants.forEach(function (v) { avail[v.id] = !!v.available; });
        $$('[data-variant-id]', scope).forEach(function (b) {
          var id = b.getAttribute('data-variant-id');
          if (id in avail) b.disabled = !avail[id];
        });
        $$('select[data-od-variant-select] option', scope).forEach(function (o) {
          if (o.value in avail) o.disabled = !avail[o.value];
        });
        var sel = $('select[data-od-variant-select]', scope);
        if (sel && sel.selectedOptions[0] && sel.selectedOptions[0].disabled) {
          var firstOk = $$('option', sel).filter(function (o) { return !o.disabled; })[0];
          if (firstOk) sel.value = firstOk.value;
        }
        if (!p.available) {
          $$('[type="submit"]', scope).forEach(function (b) { b.disabled = true; });
        }
      })
      .catch(function () { self.freshProducts[handle] = false; });
  };

  /* ---------------------------------------------------------- recommendations */

  Cart.prototype.loadRecs = function () {
    var self = this;
    var box = $('[data-od-recs]', this.root);
    if (!box) return;
    var pid = box.getAttribute('data-product-id');
    var track = $('[data-od-recs-track]', box);
    if (!pid || !track) return;

    var apply = function (html) {
      if (!html) return;
      var tmp = document.createElement('ul');
      tmp.innerHTML = html;
      var view = box.getAttribute('data-view-label');
      if (view) $$('.od-cartp__rec-view span', tmp).forEach(function (s) { s.textContent = view; });
      var limit = parseInt(box.getAttribute('data-limit'), 10) || 6;
      var items = $$('[data-od-rec]', tmp).slice(0, limit);
      if (!items.length) return;
      track.innerHTML = '';
      items.forEach(function (li) { track.appendChild(li); });
      track.scrollLeft = 0;
      self.recsState();
    };

    if (this.recsCache[pid] !== undefined) { apply(this.recsCache[pid]); return; }

    var url = withParam(withParam(withParam(this.routes.recs, 'section_id', 'od-cart-recs'), 'product_id', pid), 'limit', 10);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-od-recs-result]');
        self.recsCache[pid] = list ? list.innerHTML : '';
        apply(self.recsCache[pid]);
      })
      .catch(function () { self.recsCache[pid] = ''; });
  };

  Cart.prototype.recsState = function () {
    var box = $('[data-od-recs]', this.root);
    if (!box) return;
    var track = $('[data-od-recs-track]', box);
    var prev = $('[data-od-recs-prev]', box);
    var next = $('[data-od-recs-next]', box);
    if (!track || !prev || !next) return;
    var count = $$('[data-od-rec]', track).length;
    box.hidden = count === 0;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max || count < 2;
  };

  Cart.prototype.recsMove = function (dir) {
    var track = $('[data-od-recs-track]', this.root);
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var left = track.scrollLeft + dir * track.clientWidth;
    if (track.scrollTo) track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
    else track.scrollLeft = left;
  };

  /* ------------------------------------------------------------- events */

  Cart.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target;

      var step = t.closest('[data-od-step]');
      if (step && root.contains(step)) {
        e.preventDefault();
        var line = step.closest('[data-od-line]');
        var input = line && $('[data-od-qty]', line);
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-od-step'), 10);
        var max = parseInt(input.getAttribute('max'), 10);
        if (next < 1 || (max && next > max)) return;
        input.value = next;
        self.change(input.dataset.key, next);
        return;
      }

      var remove = t.closest('[data-od-remove]');
      if (remove && root.contains(remove)) {
        e.preventDefault();
        self.change(remove.dataset.key, 0, self.str('removed', 'Removed from your bag.'));
        return;
      }

      var wish = t.closest('[data-od-move-wish]');
      if (wish && root.contains(wish)) {
        e.preventDefault();
        self.moveToWishlist(wish);
        return;
      }

      var codeRemove = t.closest('[data-od-code-remove]');
      if (codeRemove && root.contains(codeRemove)) {
        e.preventDefault();
        self.removeCode(codeRemove.getAttribute('data-od-code-remove'));
        return;
      }

      if (t.closest('[data-od-recs-prev]')) { e.preventDefault(); self.recsMove(-1); return; }
      if (t.closest('[data-od-recs-next]')) { e.preventDefault(); self.recsMove(1); return; }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-od-qty]')) {
        var v = parseInt(t.value, 10);
        var max = parseInt(t.getAttribute('max'), 10);
        if (!v || v < 1) v = 1;
        if (max && v > max) v = max;
        t.value = v;
        self.change(t.dataset.key, v);
      } else if (t.matches('[data-od-line-size]')) {
        self.swapSize(t);
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-od-qty]')) {
        e.preventDefault();
        e.target.blur();
      }
      if (e.key === 'Escape') {
        var open = $$('details[data-od-pick][open]', root);
        if (open.length) {
          open.forEach(function (d) { d.open = false; });
          var summary = open[0].querySelector('summary');
          if (summary) summary.focus();
        }
      }
    });

    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches('[data-od-add]')) {
        e.preventDefault();
        self.add(form);
      } else if (form.matches('[data-od-code]')) {
        e.preventDefault();
        self.applyCode(form);
      }
    });

    // details does not bubble "toggle"; listen in the capture phase
    root.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('details[data-od-pick]') || !d.open) return;
      $$('details[data-od-pick][open]', root).forEach(function (o) { if (o !== d) o.open = false; });
      self.refreshProduct(d.getAttribute('data-handle'), d);
    }, true);

    root.addEventListener('focusin', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-od-variant-select]');
      if (sel) {
        var form = sel.closest('[data-od-add]');
        self.refreshProduct(form && form.getAttribute('data-handle'), form);
      }
    });
    root.addEventListener('pointerdown', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-od-variant-select]');
      if (sel) {
        var form = sel.closest('[data-od-add]');
        self.refreshProduct(form && form.getAttribute('data-handle'), form);
      }
    });

    root.addEventListener('scroll', function (e) {
      if (e.target.matches && e.target.matches('[data-od-recs-track]')) self.recsState();
    }, true);

    document.addEventListener('click', function (e) {
      $$('details[data-od-pick][open]', root).forEach(function (d) {
        if (!d.contains(e.target)) d.open = false;
      });
    });

    // a change made anywhere else (the drawer, a product page) refreshes this view
    document.addEventListener('od:cart:changed', function (e) {
      if (e.detail && e.detail.source === self.id) return;
      self.render();
    });
  };

  /* =============================================================== boot */

  function boot(scope) {
    $$('[data-od-cart]', scope || document).forEach(function (root) {
      if (root.dataset.odCartBound) return;
      root.dataset.odCartBound = '1';
      new Cart(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.OD = window.OD || {};
  window.OD.Cart = Cart;
  window.OD.carts = registry;
  window.OD.cartRequest = request;
})();
